module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cssClass
  }, [(!_vm.isLoading && !_vm.shouldRenderEmptyState) ? _c('div', {
    staticClass: "top-area scrolling-tabs-container inner-page-scroll-tabs"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('navigation-tabs', {
    attrs: {
      "scope": _vm.scope,
      "count": _vm.state.count,
      "paths": _vm.paths
    }
  }), _vm._v(" "), _c('navigation-controls', {
    attrs: {
      "new-pipeline-path": _vm.newPipelinePath,
      "has-ci-enabled": _vm.hasCiEnabled,
      "help-page-path": _vm.helpPagePath,
      "ciLintPath": _vm.ciLintPath,
      "can-create-pipeline": _vm.canCreatePipelineParsed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-list pipelines"
  }, [(_vm.isLoading) ? _c('loading-icon', {
    attrs: {
      "label": "Loading Pipelines",
      "size": "3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderEmptyState) ? _c('empty-state', {
    attrs: {
      "help-page-path": _vm.helpPagePath
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderErrorState) ? _c('error-state') : _vm._e(), _vm._v(" "), (_vm.shouldRenderNoPipelinesMessage) ? _c('div', {
    staticClass: "blank-state blank-state-no-icon"
  }, [_c('h2', {
    staticClass: "blank-state-title js-blank-state-title"
  }, [_vm._v("No pipelines to show.")])]) : _vm._e(), _vm._v(" "), (_vm.shouldRenderTable) ? _c('div', {
    staticClass: "table-holder"
  }, [_c('pipelines-table-component', {
    attrs: {
      "pipelines": _vm.state.pipelines,
      "update-graph-dropdown": _vm.updateGraphDropdown
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shouldRenderPagination) ? _c('table-pagination', {
    attrs: {
      "change": _vm.change,
      "pageInfo": _vm.state.pageInfo
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade-left"
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/template-compiler?{"id":"data-v-5cb4e2a6"}!/var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5cb4e2a6"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines.vue
// module chunks = pipelines